<!-- Footer opened -->
<div class="main-footer ht-45">
    <div class="container-fluid pd-t-0 ht-100p">
        <span> Copyright © 2022 <a href="javascript:void(0);" class="text-primary">C&M</a>. Departamento  de <a href="javascript:void(0);"> Sistemas </a> Todos los derechos reservados.</span>
    </div>
</div>
<!-- Footer closed -->